import {
  LinkPreview,
  LinkPreviewResponse,
  LinkPreviewRequestParams,
  LinkPreviewErrorResponse
} from '../../domain/models/LinkPreview';
import { LinkPreviewRepository } from '../../domain/repositories/LinkPreviewRepository';

export class LinkPreviewError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly response?: LinkPreviewErrorResponse
  ) {
    super(message);
    this.name = 'LinkPreviewError';
  }
}

export class LinkPreviewRepositoryImpl implements LinkPreviewRepository {
  private readonly API_KEY = '5906ad40d7ed9e471334f224b61f4861';
  private readonly API_URL = 'https://api.linkpreview.net';

  async getLinkPreview(
    url: string,
    options: Partial<Omit<LinkPreviewRequestParams, 'q'>> = {}
  ): Promise<LinkPreview> {
    try {
      const params = new URLSearchParams({
        q: url,
        ...(options.fields && { fields: options.fields }),
        ...(options.block_content && { block_content: 'true' })
      });

      const response = await fetch(`${this.API_URL}/?${params.toString()}`, {
        headers: {
          'X-Linkpreview-Api-Key': this.API_KEY
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new LinkPreviewError(
          'Link preview request failed',
          response.status,
          data as LinkPreviewErrorResponse
        );
      }

      // Rate limit handling
      if (response.status === 426 || response.status === 429) {
        throw new LinkPreviewError(
          'Rate limit exceeded',
          response.status,
          data as LinkPreviewErrorResponse
        );
      }

      return LinkPreview.fromResponse(data as LinkPreviewResponse);
    } catch (error) {
      if (error instanceof LinkPreviewError) {
        throw error;
      }

      console.error('Error fetching link preview:', error);
      throw new LinkPreviewError('Failed to fetch link preview', 500);
    }
  }
}
